export default __webpack_public_path__ + "static/media/bg-showcase-4.e41e673f.png";